import request from "../clientsApi";
import { API_ROUTES } from "../../config/baseURL";

// Cargar tipos y subtipos
export const getTipos = async () => {
  const res = await request(API_ROUTES.getTipoDoc, { method: "GET" });
  if (!res.ok) throw new Error("Error cargando tipos");
  return res.json();
};

// Guardar documento (FormData)
export const uploadDocumentoApi = async (formData) => {
  const res = await request(API_ROUTES.saveDocument, {
    method: "POST",
    body: formData,
  });

  return res.json();
};

// Cargar categorías (misma ruta pero otra estructura)
export const getCategorias = async () => {
  const res = await request(API_ROUTES.getTipoDoc, { method: "GET" });
  if (!res.ok) throw new Error("Error cargando categorías");
  return res.json();
};

// Obtener documentos filtrados
export const getDocumentos = async (keyword, tipos, page, limit, mime) => {
  const res = await request(API_ROUTES.getDocuments(keyword, tipos, page, limit, mime), { method: "GET" });
  return res.json();
};

// Ver PDF
export const viewPDF = async (filename) => {
  return request(API_ROUTES.viewDocument(filename), { method: "GET", responseType: "blob" });
};

// Descargar PDF
export const downloadPDF = async (filename) => {
  return request(API_ROUTES.downloadDocument(filename), { method: "GET", responseType: "blob" });
};

